import React from 'react'
import { MenuContainer } from '../../components/menuContainer/MenuContainer'
import styled from 'styled-components'
import { motion } from 'framer-motion'

const BlueBox = styled.div`
  background-color: #f3f8fb;
  margin-top: 50px;
  display: block;
  margin-left: 0;
  width: 80%;
  @media (max-width: 991px) {
    margin-top: 0;
  }
`

const Image = styled.img`
  position: relative;
  width: 98%;
  height: 320px;
  top: -50px;
  left: -20px;
  object-fit: cover;

  @media (max-width: 991px) {
    width: 100%;
    height: 250px;
    top: 0;
    left: 0;
  }
`

const Textarea = styled(motion.div)`
  padding: 0 48px 62px 48px;
  @media (max-width: 991px) {
    padding: 48px;
  }
  @media (max-width: 575px) {
    padding: 35px 30px;
  }
`

const Name = styled.div`
  width: max-content;
  margin-top: 50px;
  margin-left: auto;
  color: #848484;
  font-size: 16px;
`

const Title = styled.h3`
  font-weight: normal;
  line-height: 150%;
  @media (max-width: 767px) {
    font-size: 24px;
  }
`

const P = styled.p`
  font-size: 18px;
  line-height: 200%;
  word-break: keep-all;
  @media (max-width: 767px) {
    font-size: 16px;
  }
`

export const Greetings = () => (
  <MenuContainer title="회사소개" menu="인사말" pointRadius="50%">
    <div className="comment-wrapper">
      <motion.div
        className="comment"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{
          ease: 'easeInOut',
          duration: 1,
          y: { duration: 0.5 },
        }}
      >
        "융복합 스마트 물류로 미래를 선도하는 서진로지텍"
      </motion.div>
      <motion.div
        className="detailed-comment"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{
          ease: 'easeInOut',
          duration: 1,
          y: { duration: 0.5 },
        }}
      >
        변화와 혁신을 통한 글로벌 물류 경쟁력 확보를 위해
        <br />
        최선을 다하겠습니다.
      </motion.div>
    </div>
    <div className="d-flex justify-content-center">
      <BlueBox>
        <picture>
          <source srcSet="/greeting.webp" type="image/webp" />
          <Image src="/greeting.png" alt="서진로지텍 사진" />
        </picture>
        <Textarea
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            x: { duration: 0.7 },
          }}
        >
          <Title>
            <span style={{ color: 'var(--bs-blue)' }}>서진로지텍&nbsp;</span>
            홈페이지를
            <br />
            방문해주신 여러분, 반갑습니다.
          </Title>
          <div
            style={{
              width: '60px',
              borderTop: '2px solid var(--bs-blue)',
              margin: '30px 0',
            }}
          />
          <P>
            안녕하세요. 서진로지텍 회장 전충식입니다.
            <br />
            당사는 2024년 12월, 여수광양항만공사 광양항 서측 배후단지 5구역
            자유무역지역에 입주 허가를 취득하여,
            <br />
            복합 물류 종합 창고로서 고객사(화주)의 물류 경쟁력 제고와
            <br />
            최고 수준의 서비스를 제공할 수 있는 기반을 마련하였습니다.
            <br />
            이를 통해 수출입 화물의 통합물류체계 구축과 One-Stop 서비스 활성화를
            실현하며,
            <br />
            보세구역의 강점을 극대화하여 고객 여러분의 니즈에 신속하고
            효율적으로 대응하겠습니다.
            <br />
            앞으로도 저희 서진로지텍 임직원 일동은 정직과 정도경영을 바탕으로
            <br />
            고객에게 신뢰받는 기업으로 성장해 나갈 것이며,
            <br />
            세계 최고 수준의 융복합 스마트 창고로 도약하기 위해 끊임없는 노력과
            혁신을 멈추지 않겠습니다.
          </P>
          <Name>
            ㈜ 서진로지텍 회장
            <span
              style={{
                paddingLeft: '14px',
                color: 'var(--bs-primary)',
                letterSpacing: '5px',
                fontWeight: '600',
                fontSize: '18px',
              }}
            >
              전충식
            </span>
          </Name>
        </Textarea>
      </BlueBox>
    </div>
  </MenuContainer>
)
